<div class="option-content-particularity">
    <span class="option-title">PAF Garantizado </span>

    <div class="actions">
        <input type="checkbox" [checked]="isGuaranteedPAF" (click)="setGuaranteedPAF()" class="checkbox"/>
    </div>
</div>